import httpClient from '@/http-client'

export const getAssigned = (Options = {}) => {
  return httpClient
    .get('/api/v1/reports/product-addon-info/assigned', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const getNotAssign = (Options = {}) => {
  return httpClient
    .get('/api/v1/reports/product-addon-info/not-assign', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export default { getAssigned, getNotAssign }
